import { render, staticRenderFns } from "./PopOver.vue?vue&type=template&id=44f27821&scoped=true&"
import script from "./PopOver.vue?vue&type=script&lang=js&"
export * from "./PopOver.vue?vue&type=script&lang=js&"
import style0 from "./PopOver.vue?vue&type=style&index=0&id=44f27821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f27821",
  null
  
)

export default component.exports